<template>
  <div>
   <!-- 协议提示 -->
    <el-dialog
      :visible.sync="protocolDialogVisible"
      width="400px"
      :before-close="closeDialog">
      <span slot="title" class="title"><img src="../../assets/tip-icon.png"/>用户协议及隐私保护</span>
      <span class="protocolContent">请您认真阅读<a @click="openPopup('1')">
        <template v-if="showBoXueGu">
          《博学谷用户服务协议》
        </template>
        <template v-else>
          《用户服务协议》
        </template>
        </a
        >和<a @click="openPopup('2')">《隐私政策》</a>的全部条款，同意后可以开始使用我们的服务。
        </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialog()">不同意</el-button>
        <el-button type="primary" @click="isProtocolLoginYes()">同意并登录</el-button>
      </span>
    </el-dialog>
    <!-- 协议提示 end-->
    </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
  
  export default {
   
    props: ["visible"],
    data() {
      return {
        v:true,
        showBoXueGu:true,
      }
    },
    mounted(){
      if(window.location.search.indexOf('match')>-1){
        this.showBoXueGu=false
      }
    },
     components: {
      
    },
     computed: {
    ...mapState(["protocolDialogVisible"]),
  },
  watch:{
    protocolDialogVisible:{
      handler(val){
       
      }
    }
  },
    methods:{
       ...mapMutations(["protocolDialogshow", "protocolDialogHidden","isProtocolLoginYes"]),
     closeDialog(){
        this.protocolDialogHidden()
     },
     ok(){
         this.protocolDialogHidden()
     },
     openPopup(type) {
      if (type == 1) {
        window.open("https://file.boxuegu.com/app/agreement/bxg_service.html");
      } else {
        window.open("https://file.boxuegu.com/app/agreement/bxg_policy.html");
      }
    },
    }
  }
</script>

<style lang="scss" scoped>
::v-deep{
  .el-dialog__body{
    padding: 22px 40px 22px 60px !important;
  }
}
.title{
  font-size: 16px;
font-family: PingFangSC-Medium, PingFang SC;
font-weight: 500;
color: #1D2129;
  display: flex;
  align-content:center;
  img{
    width: 20px;height:20px;
    margin-right:8px;

  }
}
 .protocolContent{
  font-size: 14px;
font-family: PingFangSC-Regular, PingFang SC;
font-weight: 400;
color: #4E5969;
line-height: 20px;
img{width: 20px;}
  a{
    color:#165DFF

  }
  a:hover{
    cursor: pointer;
  }
 }
::v-deep
 .el-dialog{
  border-radius: 8px;
   .el-button{
      border-radius: 4px;
    }
    .el-button--primary{
      background-color:#165DFF;
      border-color:#165DFF;
    
    }
    .el-button--default:focus, .el-button--default:hover {
      color: #165DFF;
      border-color: #c6e2ff;
      background-color: #ecf5ff;
    }
 }


</style>